import React from "react";
import { useQuery } from "@tanstack/react-query";
import { useParams, useNavigate } from "react-router-dom";
import { getAlert } from "../../api"; // تأكد من أن الدالة `getAlert` متاحة في API

export default function SingleAlert() {
    const { id } = useParams();
    const { data: alert, isFetching } = useQuery({
        queryKey: ["alert", id],
        queryFn: () => getAlert(id),
        initialData: null,
    });
    const navigate = useNavigate();

    if (!isFetching && !alert) {
        navigate("/home/not-found");
        return null;
    }

    return (
        <div className="w-full min-h-screen py-10">
            {/* Hero Section */}
            <div
                className="relative w-full h-64 lg:h-[40vh] bg-cover bg-center"
            >
                <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-black opacity-50"></div>
                <div className="relative text-center text-grey-800 px-4 py-10">
                    <h1 className="text-3xl lg:text-5xl font-extrabold">{alert?.title}</h1>
                    <p className="mt-4 text-sm lg:text-base">{new Date(alert?.pubDate).toLocaleDateString()}</p>
                </div>
            </div>

            {/* Content Section */}
            <div className="px-10 text-right">
                <div className="mx-auto bg-white border shadow-lg rounded-lg mt-10 p-6 lg:p-10">
                    <h2 className="text-2xl font-semibold mb-4">التفاصيل </h2>
                    <p className="text-gray-700 leading-relaxed" dangerouslySetInnerHTML={{ __html: alert?.description || '' }}></p>

                    <span>
                        : المصدر
                        &nbsp;
                        <a href="https://meteosudan.sd/alerts/" className="text-primary">
                            هيئة الأرصاد الجوية السودانية
                        </a>
                    </span>

                </div>

            </div>

        </div>
    );
}
